/* TODO: t() */
import React, { Component } from 'react';
import { View } from 'react-native';

import FormFieldEditor from '../helpers/FormFieldEditor';
import { Checkbox } from '../../../uiold';

import MarketSelectorElement from '../MarketSelectorElement';

type EditorViewProps = {
  data: {
    [key: string]: unknown;
  };
  updateValue: (key: string, newValue: unknown) => void;
  renderNameInput: () => ReactElement;
  renderLabelInput: () => ReactElement;
};

function EditorView(props: EditorViewProps) {
  let { data, updateValue, renderNameInput, renderLabelInput } = props;
  return (
    <View>
      {renderNameInput()}
      {renderLabelInput()}
      <Checkbox
        text="Required"
        isChecked={!!data.is_required}
        onChange={(value) => updateValue('is_required', value)}
      />
      <Checkbox
        text="Disable Select All Checkbox"
        isChecked={!!data.disableSelectAll}
        onChange={(value) => updateValue('disableSelectAll', value)}
      />
      <Checkbox
        text="Display Dates as Calendar"
        isChecked={!!data.calendarView}
        onChange={(value) => updateValue('calendarView', value)}
      />
      <Checkbox
        text="Hide this field in signup form"
        isChecked={!!data.hiddenInForm}
        onChange={(value) => updateValue('hiddenInForm', value)}
      />
    </View>
  );
}

type Props = {
  parent: MarketSelectorElement;
};

class MarketSelectorFieldEditorView extends Component<Props> {
  render() {
    let { parent } = this.props;
    return <FormFieldEditor component={EditorView} parent={parent} />;
  }
}

export default MarketSelectorFieldEditorView;
